import { createFileRoute, Outlet } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"
import MCALLEN_THEME from "@/utilities/json/McAllenTheme"

export const Route = createFileRoute("/settings")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    qrLookupID?: string
  } => {
    return cleanEmptyParams({
      qrLookupID: (search.qrLookupID as string) || "",
    })
  },
  beforeLoad: ({ context, search }) => {
    if (search.qrLookupID) {
      context.setScannedArea({
        qrLookupID: search.qrLookupID,
        theme: MCALLEN_THEME,
      })
      context.setDocumentThemeMode("whiteLabel")
    }
  },
  component: Outlet,
})
